function deviceIdStr(d) {
  if (d == null) return '';
  const id = typeof d === 'object' ? d._id : d;
  if (id == null) return '';
  return typeof id.toString === 'function' ? id.toString() : String(id);
}

function isCurtainLike(type) {
  return type === 3 || type === 5 || type === 6;
}

function normalizeItems(items) {
  if (items == null) return [];
  if (Array.isArray(items)) return items;
  if (typeof items === 'object') return Object.values(items);
  return [];
}

/**
 * 개별 조작으로 켜져 있던 가상버튼을 끈 뒤, 아직 씬으로 켜져 있는 다른 멤버를 행에 드러낸다.
 * 밝기/색은 유지하고, onVirtual 이었던 멤버는 켜짐으로 보여 준다.
 */
function applyMemberRelease(devices, virtualDocs, reportedMemberId) {
  const reported = deviceIdStr(reportedMemberId);
  const docs = virtualDocs || [];
  const linked = new Set(docs.map((vd) => deviceIdStr(vd)));
  const released = new Set();
  const turnedOff = (devices || []).map((d) => {
    if (
      d &&
      d.isVirtual &&
      Number(d.item && d.item.onoff) === 1 &&
      linked.has(deviceIdStr(d))
    ) {
      released.add(deviceIdStr(d));
      return { ...d, item: { ...d.item, onoff: 0 } };
    }
    return d;
  });
  if (released.size === 0) return turnedOff;

  const reveal = new Set();
  const oriPercent = new Map();
  for (const vd of docs) {
    if (!released.has(deviceIdStr(vd))) continue;
    for (const it of normalizeItems(vd && vd.items)) {
      const id = deviceIdStr(it);
      if (!id || id === reported) continue;
      reveal.add(id);
    }
    for (const it of normalizeItems(vd && vd.oriItems)) {
      if (!isCurtainLike(it && it.type) || it.item == null || it.item.percent == null) continue;
      const id = deviceIdStr(it);
      if (id) oriPercent.set(id, Number(it.item.percent));
    }
  }

  return turnedOff.map((d) => {
    if (!d || d.isVirtual || d.onVirtual !== true || !reveal.has(deviceIdStr(d))) {
      return d;
    }
    if (isCurtainLike(d.type)) {
      const percent = oriPercent.has(deviceIdStr(d)) ? oriPercent.get(deviceIdStr(d)) : d.item && d.item.percent;
      return {
        ...d,
        onVirtual: false,
        item: {
          ...d.item,
          percent,
          close: Number(percent) >= 100 ? 1 : 0,
        },
      };
    }
    return {
      ...d,
      onVirtual: false,
      item: {
        ...d.item,
        onoff: 1,
        state: { ...(d.item && d.item.state), onoff: 1 },
      },
    };
  });
}

/**
 * 가상버튼 직후 멤버 보고를 무시할지.
 * 방금 보낸 전원과 같은 보고만 메아리로 본다. 반대 전원은 개별 조작이다.
 */
function memberReleaseSuppressed(entry, now, reportOnoff) {
  if (!entry || !(now < entry.until)) return false;
  if (entry.onoff == null || reportOnoff == null) return true;
  const command = Number(entry.onoff) === 1 ? 1 : 0;
  const reported = Number(reportOnoff) === 1 ? 1 : 0;
  return command === reported;
}

/** 저장 밝기/색으로 다시 켠 보고는 씬 메아리가 아니다. */
function isIndividualSceneTakeover(device, onoff, bright, color) {
  if (!device || device.onVirtual !== true || Number(onoff) !== 1) return false;
  return Number(device.item && device.item.bright) === Number(bright)
    && Number(device.item && device.item.color) === Number(color);
}

/** 씬으로 켜진 조명의 개별 cmd d 는 전원만 반영한다. 밝기/색은 저장값을 유지한다. */
function lampReportState(device, values) {
  if (device && device.onVirtual === true) {
    return { onoff: values.onoff };
  }
  return values;
}

module.exports = {
  applyMemberRelease,
  lampReportState,
  memberReleaseSuppressed,
  isIndividualSceneTakeover,
};
